import { useMutation } from 'react-query';

import { updateProject as mutationFn } from 'api/endPoints/updateProject';

export const useMutationRenameProject = () => {
    return useMutation<any, QueryError, IRenameProject>({ mutationFn: (params) => mutationFn(params) });
};

interface IRenameProject {
    projectId: number;
    projectName: string;
}
